import {
  Badge,
  ListItemIcon,
  ListItemText,
  MenuItem,
  Tooltip
} from '@mui/material'
import React from 'react'
import { Link as RouterLink } from 'react-router-dom'

import Icon from 'components/Icon'
import { type SubNavItemConfig } from 'components/navigation/Nav/use-gremlin-navigation'
import { muiTheme } from 'mui-theme'

export const SubNavItem: React.FC<{
  subnavItem: SubNavItemConfig
  handleClose(): void
}> = ({ subnavItem, handleClose }) => {
  return (
    <Tooltip
      key={subnavItem.name}
      placement="right"
      title={
        subnavItem.showNotification
          ? 'Your team has a pending cluster access request'
          : ''
      }
    >
      <MenuItem
        component={RouterLink}
        sx={{
          '&:hover': {
            backgroundColor: 'transparent'
          }
        }}
        to={subnavItem.route}
        onClick={handleClose}
      >
        {subnavItem.icon && (
          <ListItemIcon
            sx={{
              justifyContent: 'center',
              color: subnavItem.disabled
                ? muiTheme.palette.grey[600]
                : muiTheme.palette.common.black
            }}
          >
            <Icon
              css={[
                {
                  width: muiTheme.spacing(2.5),
                  height: muiTheme.spacing(2.5),
                  transition: 'opacity 150ms ease 0s'
                }
              ]}
              data-test-navigation-notification={subnavItem.showNotification}
              icon={subnavItem.icon}
            />
          </ListItemIcon>
        )}
        <ListItemText
          primary={subnavItem.text}
          primaryTypographyProps={{
            variant: 'body2'
          }}
        />
        {subnavItem.showNotification && (
          <ListItemIcon
            sx={{
              alignItems: 'center',
              justifyContent: 'flex-start'
            }}
          >
            <Badge
              badgeContent=""
              color="warning"
              sx={{
                left: muiTheme.spacing(1)
              }}
              variant="dot"
            />
          </ListItemIcon>
        )}
      </MenuItem>
    </Tooltip>
  )
}
